import type * as React from 'react';
import { ConfigurationCard } from '../ConfigurationCard.tsx';

export type WidgetConfigurationCardProps = React.ComponentProps<
  typeof ConfigurationCard
>;

/**
 * Alias del `ConfigurationCard` per il Drawer di configurazione dei Widget.
 */
export function WidgetConfigurationCard(props: WidgetConfigurationCardProps) {
  return <ConfigurationCard {...props} />;
}
